<template>
  <div id="bank_list" class="bank-list">
    <ul class="ul">
      <li
        v-for="item in showCountryCodeList"
        :key="item.id"
        @click="choiseItem(item)"
        class="li"
        :class="{
          ac: item.countryCode === countryCodeInfo.countryCode,
        }"
      >
        <div class="seach_li_text">
          <div class="col2">
            <div class="abbreviationName">
              <span class="code">
                {{ item.countryCode }}
              </span>
              <span class="name">
                {{ item.countryCodeName }}
              </span>
            </div>
          </div>
          <img src="@/assets/images/arrow-right1.svg" alt="" class="arrow" />
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "CountryCodeList",
  props: ["countryCodeList", "searchText", "countryCodeInfo"],
  components: {},
  data() {
    return {};
  },
  computed: {
    showCountryCodeList() {
      function escapeRegExp(text) {
        return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
      }
      const escapedSearchText = escapeRegExp(this.searchText);
      const reg = new RegExp(escapedSearchText, "i");
      return this.countryCodeList.filter((item) => {
        return reg.test(item.countryCode + item.countryCodeName);
      });
    },
  },

  mounted() {},
  beforeDestroy() {},

  methods: {
    choiseItem(item) {
      this.$emit("choiseItem", {
        type: "countryCode",
        val: item,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#bank_list.bank-list {
  ul.ul {
    li.li {
      margin: 0;
      .seach_li_text {
        min-height: 0.48rem;
        height: auto;
        .col2 {
          .abbreviationName {
            margin-bottom: 0;
            line-height: 0.24rem;
            font-weight: 500;
            display: flex;
            align-items: center;
            .code {
              width: 0.5rem;
            }
            .name {
            }
          }
        }
        img {
        }
      }
    }
  }
}
</style>
